module.exports = __webpack_public_path__ + "img/banner_info.38a1898f.png";